import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { planApiKeyStore } from '../../../api/plan-api-key-store';
import { TabPanel } from '../../../components/tab-panel';
import { projectPlanFormSchema } from './project-plan-form.schema';
import { CreatePlanComponent } from './create-plan/create-plan.component';
import { PlanMappedComponent } from './map-plan/plan-mapped.component';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface PlanRequestArgs {
  customerID?: number;
  projectID?: number;
  officeID?: number;
  unitID?: number;
}

interface ProjectPlanDialog {
  editPlan: any;
  planData: any[];
  onClosed: () => void;
  planRequestArgs?: PlanRequestArgs;
}
export const ProjectPlanDialog = ({ editPlan, planData, onClosed, planRequestArgs }: ProjectPlanDialog) => {
  const [planReqArgs, setPlanReqArgs] = useState<any>(planRequestArgs);
  const [value, setTabValue] = useState('create');

  const handleTabsChange = (event: any, value: any) => {
    setTabValue(value);
  };

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'xl'}
    //  onClose={onClosed}
    >
      <DialogTitle id="form-dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="create" label={<div style={styling.tabHeading}>{editPlan.planID ? 'UPDATE PLAN' : 'ADD NEW PLAN'}</div>} />
          <Tab value="mapped" label={<div style={styling.tabHeading}>ADD EXISTING PLAN</div>} hidden={editPlan.planID} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <TabPanel selectedValue={value} value="create">
          <CreatePlanComponent
            config={{
              saveConfig: editPlan.planID ? planApiKeyStore.updatePlan() : planApiKeyStore.createPlan(),
              invalidateRoute: () =>
                planApiKeyStore.getPlans({
                  // officeID: planReqArgs.officeID,
                  projectID: planReqArgs.projectID,
                }),
            }}
            data={editPlan}
            yupSchema={projectPlanFormSchema}
            planRequestArgs={planReqArgs}
            onClosed={onClosed}
          />
        </TabPanel>
        <TabPanel selectedValue={value} value="mapped">
          <PlanMappedComponent planData={planData} planRequestArgs={planReqArgs} onClosed={onClosed} />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
